import EmblaCarousel from 'embla-carousel';
import { autoplay } from '../helpers/autoplay';

(() => {
  const logoCarousels = document.querySelectorAll('.m03');
  const options = {
    loop: true,
    align: 'center',
    draggable: true
  };

  function slideWidths(slides) {
    let slideWidth = 0;
    slides.forEach(slide => {
      const slideStyle = slide.currentStyle || window.getComputedStyle(slide);
      slideWidth = slideWidth + slide.clientWidth + (parseInt(slideStyle.marginLeft, 10) * 2);
    });
    return slideWidth;
  }

  const checkWidth = (carousel, embla, slides, autoplayer) => {
    if ((slideWidths(slides) / 1.3) < window.innerWidth) {
      carousel.classList.add('is-static');
      autoplayer.stop();
    } else {
      autoplayer.play();
      carousel.classList.remove('is-static');
    }
    embla.reInit();
  };

  logoCarousels.forEach(carousel => {
    const slides = carousel.querySelectorAll('.m03__slide');
    const viewport = carousel.querySelector('.m03__wrapper');
    const embla = EmblaCarousel(viewport, options);
    const autoplayer = autoplay(embla, 4000);
    embla.on('init', autoplayer.play);
    embla.on('init', () => {
      checkWidth(carousel, embla, slides, autoplayer);
    });

    embla.on('resize', () => {
      checkWidth(carousel, embla, slides, autoplayer);
    });
  });
})();
